import React, { useEffect, useState } from "react";
import { apiGetBranding } from "@/lib/api";

let _cachedLogo = null;
let _cachedLoaded = false;

const useCustomLogo = () => {
  const [logo, setLogo] = useState(_cachedLogo);
  useEffect(() => {
    if (!_cachedLoaded) {
      apiGetBranding()
        .then((d) => {
          _cachedLogo = d?.logo_url || null;
          _cachedLoaded = true;
          setLogo(_cachedLogo);
        })
        .catch(() => {
          _cachedLoaded = true;
        });
    }
    const onChange = (e) => {
      _cachedLogo = e?.detail?.logoUrl || null;
      setLogo(_cachedLogo);
    };
    window.addEventListener("mb-branding-change", onChange);
    return () => window.removeEventListener("mb-branding-change", onChange);
  }, []);
  return logo;
};

export const BrandMark = ({ size = 40, className = "" }) => {
  const numericSize = typeof size === "number" ? size : 40;
  const customLogo = useCustomLogo();

  if (customLogo) {
    return (
      <img
        src={customLogo}
        alt="MastiBazaar"
        width={numericSize}
        height={numericSize}
        className={`${className} rounded-2xl object-cover`}
        style={{ width: numericSize, height: numericSize }}
      />
    );
  }

  return (
    <svg
      width={numericSize}
      height={numericSize}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="mb-frame" x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#8B5CF6" />
          <stop offset="45%" stopColor="#C026D3" />
          <stop offset="100%" stopColor="#F97316" />
        </linearGradient>
        <linearGradient id="mb-plate" x1="0" y1="0" x2="0" y2="48" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#1F1235" />
          <stop offset="100%" stopColor="#0B0416" />
        </linearGradient>
        <linearGradient id="mb-m-face" x1="10" y1="10" x2="38" y2="40" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#FBBF24" />
          <stop offset="55%" stopColor="#F97316" />
          <stop offset="100%" stopColor="#C026D3" />
        </linearGradient>
        <linearGradient id="mb-m-shadow" x1="10" y1="14" x2="38" y2="40" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#7C2D92" />
          <stop offset="100%" stopColor="#3B0764" />
        </linearGradient>
      </defs>
      <rect x="1.2" y="1.2" width="45.6" height="45.6" rx="12" fill="url(#mb-plate)" stroke="url(#mb-frame)" strokeWidth="2.4" />
      <rect x="4" y="4" width="40" height="40" rx="9.5" fill="none" stroke="#ffffff" strokeOpacity="0.06" strokeWidth="1" />
      <path d="M11.5 37.5 V15.5 L19.5 15.5 L25.5 25.5 L31.5 15.5 L39.5 15.5 V37.5 L35 37.5 V23 L28 34.5 L23 34.5 L16 23 V37.5 Z" fill="url(#mb-m-shadow)" />
      <path d="M10 36 V14 L18 14 L24 24 L30 14 L38 14 V36 L33.5 36 V21.5 L26.5 33 L21.5 33 L14.5 21.5 V36 Z" fill="url(#mb-m-face)" />
      <path d="M18 14 L24 24 L30 14" stroke="#FDE68A" strokeOpacity="0.55" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
};
